import { useContext } from 'react'

import { ConfigContext } from '@/providers/ConfigContext'
import type { ConfigContextValue } from '../types'

export function useConfig(): ConfigContextValue {
  const ctx = useContext(ConfigContext)

  if (!ctx) {
    throw new Error('useConfig must be inside ConfigProvider')
  }
  return ctx
}
